import {IUser} from '../../models';
import {Recipient} from './types';

export const createNewItemFromPaste = (query: any): Recipient[] => {
  const newItems: Recipient[] = [];

  query.forEach((item: { email: string; }) => {
    newItems.push(createNewItemFromQuery(item.email));
  });

  return newItems;
}

export const getInitialValue = (value: string[] | undefined | null, recipients: Recipient[]): Recipient[] => {
  const initialValue: Recipient[] = [];

  if (!value || !value?.length) {
    return initialValue;
  }

  return value.reduce((acc: Recipient[], email: string): Recipient[] => {
    const found = recipients.find((item: Recipient) => item.email === email);

    if (found) {
      acc.push(found);
    } else {
      acc.push(createNewItemFromQuery(email));
    }
    return acc;
  }, initialValue);
}

export const createNewItemFromQuery = (query: string) => {
  return {
    uid: null,
    email: query,
  };
};

export const onFilerRecipients = (query: string, item: Recipient) => {
  /*
   * itemPredicate
   */
  return item.email.toLowerCase().includes(query.toLowerCase());
};

export const recipientsToOptions = (recipients: Partial<IUser>[]) => {
  const toOption = ({email, uid}: Partial<IUser>) => ({
    email: email as string,
    uid: uid as string
  });

  return recipients.map(toOption);
};
